export default "__VITE_ASSET__CZdo3eTP__"